import validEmail from "./validEmail.directive";

const validEmailModule = angular
  .module("app.directives.validEmail", [])
  .directive("validEmail", validEmail);

export default validEmailModule;



// WEBPACK FOOTER //
// ./src/directives/validEmail/validEmail.module.js